"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var errors_1 = require("./errors");
var Partition = /** @class */ (function () {
    function Partition(sdlc, envNum, region, shard) {
        if (!sdlc || !region) {
            throw new errors_1.XidError('partition must contain sdlc and region');
        }
        this.sdlc = sdlc;
        this.envNum = envNum;
        this.region = region;
        this.shard = shard || null;
    }
    Partition.parse = function (str) {
        var parts = str.split('.');
        var sdlcParts = (parts[0] || '').split('-');
        var sdlc = sdlcParts[0];
        var envNum = sdlcParts[1] ? parseInt(sdlcParts[1]) : null;
        var region = parts[1];
        var shard = parts[2] || null;
        return new Partition(sdlc, envNum, region, shard);
    };
    Partition.prototype.toString = function () {
        var str = this.sdlc;
        if (this.envNum !== null) {
            str += "-" + this.envNum;
        }
        str += "." + this.region;
        if (this.shard !== null) {
            str += "." + this.shard;
        }
        return str;
    };
    return Partition;
}());
exports.Partition = Partition;
